import type { FC } from "react";
import { useCallback } from "react";
import { BulletedListButton } from "../message/editor/plugins/toolbar/bulleted-list-button";
import { OrderedListButton } from "../message/editor/plugins/toolbar/ordered-list-button";
import type { ToolbarProps } from "../message/editor/plugins/toolbar/props";
import { ButtonMenu } from "./button-menu";
import type { MenuContext } from "./use-menu-reducer";

export const ListMenu: FC<ToolbarProps & { menu: MenuContext; activeBlockType: string }> = ({
  menu,
  activeBlockType,
  disabled,
}) => {
  const makeButton = useCallback(
    (buttonProps: ToolbarProps) =>
      activeBlockType === "number" ? (
        <OrderedListButton activeBlockType={true} {...buttonProps} />
      ) : (
        <BulletedListButton activeBlockType={activeBlockType === "bullet"} {...buttonProps} />
      ),
    [activeBlockType],
  );

  return (
    <ButtonMenu
      button={makeButton}
      disabled={disabled}
      open={menu.state.list.isOpen}
      onClose={menu.close("list")}
      onOpen={menu.open("list")}
      title="List menu"
    >
      <BulletedListButton
        disabled={disabled}
        label="Bulleted list"
        onClick={menu.close("list")}
        activeBlockType={activeBlockType === "bullet"}
      />
      <OrderedListButton
        disabled={disabled}
        label="Ordered list"
        onClick={menu.close("list")}
        activeBlockType={activeBlockType === "number"}
      />
    </ButtonMenu>
  );
};
